export default __webpack_public_path__ + "static/media/Vector 1.d4fcfd7a.svg";